module.exports = "/_next/static/images/d1c88990f43c69b53daf652656aee1e2-logos-compliance.png";